import axios from "axios";
import { API_BASE_URL } from "@/lib/apiBase";

/**
 * Search mentionable users and referenceable channels for the current org.
 */
export async function searchContentReferences(
  accessToken,
  {
    orgId,
    q = "",
    types,
    conversationId,
    contextType,
  } = {}
) {
  const params = { org_id: orgId, q };
  if (types?.length) params.types = types.join(",");
  if (conversationId != null) params.conversation_id = conversationId;
  if (contextType) params.context_type = contextType;
  const { data } = await axios.get(`${API_BASE_URL}/references/search`, {
    headers: { Authorization: `Bearer ${accessToken}` },
    params,
  });
  return data || { users: [], channels: [], teams: [] };
}
